module.exports = __webpack_public_path__ + "media/images/PrevailV-2dcd80f125a3a109122297eb9b82dc08.png";